<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Prática de Linguagem"
              v-model="form.filters.nome"
              outlined
              dense
              @keyup.enter="buscarPraticasLinguagem"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Código da Habilidade"
              v-model="form.filters.codigoHabilidade"
              outlined
              dense
              @keyup.enter="buscarPraticasLinguagem"
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarPraticasLinguagem()"
              ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterPraticasLinguagem()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listPraticasLinguagem"
        :items-per-page="10"
        :footer-props="$footerProps"
        :no-data-text="this.$user.permissions.includes('pratica.linguagem.listar')? dataText: 'Não há registros a serem exibidos.'"
        show-expand
      >
        <template v-slot:[`item.habilidades`]="{ item }">
          {{ item.habilidades.join(' / ') }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="blue-grey lighten-5">
            <p class="ml-4 my-0 text-wrap mx-70vw"><strong>{{ item.descricao }}</strong></p>
          </td>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarPraticasLinguagem(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterPraticasLinguagem(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarPraticasLinguagem(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarPraticasLinguagemDialog
      :visible="dialogManterPraticasLinguagem.visible"
      :content="dialogManterPraticasLinguagem.content"
      :edit="dialogManterPraticasLinguagem.edit"
      @onClose="dialogManterPraticasLinguagem.close()"
      @onSave="buscarPraticasLinguagem()"
    ></CadastrarEditarPraticasLinguagemDialog>
    <VisualizarPraticasLinguagemDialog
      :visible="dialogVisualizarPraticasLinguagem.visible"
      :content="dialogVisualizarPraticasLinguagem.content"
      @onClose="dialogVisualizarPraticasLinguagem.close()"
    ></VisualizarPraticasLinguagemDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { PraticaLinguagem } from '~/commons/classes/pratica-linguagem';
import DataTableMixin from '~/mixins/datatables.mixin'
import PraticasLinguagemService from '~/services/praticas-linguagem.service';
import CadastrarEditarPraticasLinguagemDialog from './dialogs/CadastrarEditarPraticasLinguagemDialog.vue';
import VisualizarPraticasLinguagemDialog from './dialogs/VisualizarPraticasLinguagemDialog.vue';

export default {
  name: "ManterPraticasLinguagemView",
  mixins: [PraticasLinguagemService, DataTableMixin],
  components: {
    CadastrarEditarPraticasLinguagemDialog,
    VisualizarPraticasLinguagemDialog
  },
  data: () => ({
    dialogManterPraticasLinguagem: Dialog.Build(),
    dialogVisualizarPraticasLinguagem: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        codigoHabilidade: null,
        ativo: null
      },
      lists: {
        listPraticasLinguagem: []
      }
    },
    headers: [
      { text: "Prática de Linguagem", align: "center", value: "nome" },
      { text: "Código da Habilidade", align: "center", value: "habilidades" },
      { text: "O que será avaliado", align: "center", value: "data-table-expand" },
      { text: "Situação", align: "center", value: "ativo" },
      { text: "Ações", align: "center", value: "acoes", sortable: false }
    ],
    dataText: ''
  }),
  methods: {
    openDialogManterPraticasLinguagem(pratica) {
      pratica
        ? this.$visualizarPraticasLinguagem(pratica).then(({ data }) => this.dialogManterPraticasLinguagem.open(new PraticaLinguagem(data.resposta), true))
        : this.dialogManterPraticasLinguagem.open(PraticaLinguagem.Build());
    },
    openDialogVisualizarPraticasLinguagem(pratica) {
      this.$visualizarPraticasLinguagem(pratica).then(({ data }) => this.dialogVisualizarPraticasLinguagem.open(new PraticaLinguagem(data.resposta)));
    },
    buscarPraticasLinguagem() {
      this.$buscarPraticasLinguagem({ params: this.form.filters }).then(({ data }) => {
        this.form.lists.listPraticasLinguagem = data.itens;
        if(!data.itens?.length) {
          this.dataText = 'Não há registros a serem exibidos.';
        } else {
          this.dataText = '';
        }
      });
    },
    inativarAtivarPraticasLinguagem(pratica) {
      this.$swal({
        text: `Deseja ${pratica.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`
      }).then(() => {
        this.$inativarAtivarPraticaLinguagem(pratica.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarPraticasLinguagem();
        });
      });
    },
    resetForm() {
      this.$clearFilters(this.form);
      this.$resetForm();
      this.dataText = '';
    }
  }
};
</script>
